import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { site } from '../data/site';
type CtaBandProps = {
  title: string;
  text: string;
  showSolutionsLink?: boolean;
};
export function CtaBand({
  title,
  text,
  showSolutionsLink = true
}: CtaBandProps) {
  return <section className="border-y border-line bg-bone" aria-labelledby="cta-titre" data-id="element-16" data-mp="mh1dstj8dyc0">
      <div className="mx-auto grid max-w-content items-end gap-10 px-6 py-16 md:py-20 lg:grid-cols-[1.2fr_1fr]" data-id="element-17" data-mp="rg4igcvau2jg">
        <div data-id="element-18" data-mp="vflr1f60vfsu">
          <h2 id="cta-titre" className="text-3xl font-semibold leading-tight tracking-tight text-ink md:text-4xl" data-id="element-19" data-mp="vf3ndxh15zaw">
            {title}
          </h2>
          <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-20" data-mp="1579df1nq26ng">{text}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:flex-col lg:items-stretch" data-id="element-21" data-mp="1a6cigm3pccvf">
          <a href={site.phoneHref} className="inline-flex items-center justify-center gap-2 bg-signal px-6 py-4 text-[15px] font-medium text-white transition-colors duration-150 ease-smooth hover:bg-signal-dark" data-id="element-22" data-mp="1f4nrwvq34ld4">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="1u6pcp4w64lv6" />
            {site.phoneDisplay}
          </a>
          <a href={site.emailHref} className="inline-flex items-center justify-center gap-2 border border-ink px-6 py-4 text-[15px] font-medium text-ink transition-colors duration-150 ease-smooth hover:bg-ink hover:text-white" data-id="element-24" data-mp="1p9h1xpdcnk3y">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="2czt7itl4h4rd" />
            {site.email}
          </a>
          {showSolutionsLink && <Link to="/contact" className="inline-flex items-center justify-center gap-2 text-[15px] font-medium text-ink underline decoration-line underline-offset-4 transition-colors duration-150 ease-smooth hover:text-signal" data-id="element-26" data-mp="2868fdi67n503">
              Décrire votre projet
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-27" data-mp="2vvjbungj2d8f" />
            </Link>}
        </div>
      </div>
    </section>;
}